import React from 'react';

const LaptopMockup = ({ src }) => (
  <div className="flex flex-col items-center w-full transform transition-transform duration-500 hover:-translate-y-2 cursor-pointer">
    {/* Screen */}
    <div className="relative w-[92%] aspect-[16/10] bg-black rounded-t-xl md:rounded-t-2xl p-1.5 md:p-2 border border-gray-700 shadow-[0_20px_50px_rgba(0,0,0,0.5)]">
      <div className="absolute top-[4px] left-1/2 -translate-x-1/2 w-1 h-1 md:w-1.5 md:h-1.5 bg-gray-500 rounded-full z-10" />
      <div className="w-full h-full bg-white overflow-hidden relative rounded-sm">
        <img src={src} className="w-full h-full object-cover" alt="Dashboard" />
      </div>
    </div>
    {/* Base */}
    <div className="w-full h-3 md:h-4 bg-gradient-to-b from-[#f3f4f6] to-[#9ca3af] rounded-b-xl relative shadow-[0_15px_30px_rgba(0,0,0,0.4)] border border-gray-400">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/5 h-1 md:h-1.5 bg-[#6b7280] rounded-b-md shadow-inner" />
    </div>
  </div>
);

export default LaptopMockup;
